/* global localStorage */
import types from './types'
import firebase from 'firebase'

const db = firebase.database();
const auth = firebase.auth();
var _getMembersFromFunction = firebase.functions().httpsCallable('getMembers');

export const getCurrentUser = () => {

  return (dispatch) => {

    auth.onAuthStateChanged((user) => {
      getModelUserByUserAndDispatch(dispatch, user);
      _getMembers(user, dispatch)
    });
  }
}

const _getMembers = (user, dispatch) => {

  if (user) {
    _getMembersFromFunction()
      .then(result => {

        dispatch({ type: types.GET_MEMBERS, payload: result.data.members })
      }).catch(function(error) {
        var code = error.code;
        var message = error.message;
        console.error(code, message)
      });
  } else {
    dispatch({ type: types.GET_MEMBERS, payload: null })
  }
}

function getModelUserByUserAndDispatch(dispatch, user) {
  if (!user) {
    dispatch({ type: types.GET_CURRENT_USER, payload: null });
    return
  }

  try {
    const currentUser = JSON.parse(localStorage.getItem('currentModelUser'));
    if (currentUser && currentUser.id === user.uid) {
      dispatch({ type: types.GET_CURRENT_USER, payload: currentUser });
    }
  } catch (e) {}

  db.ref('users').child(user.uid).once('value').then((snapshot) => {
    const result = snapshot.val();
    localStorage.setItem('currentModelUser', JSON.stringify(result));
    dispatch({ type: types.GET_CURRENT_USER, payload: result });
  });
}



// WEBPACK FOOTER //
// ./src/action/index.js